<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back"
            :disabled="backButtonStatus" />
          <action-button @click="up" icon="up" bold :text="lang.button_Up" :tooltip="lang.button_Up"
            :disabled="upButtonStatus" />

          <action-button v-if="buttonIsVisible && currentUser.role != 'Reader' && tabStatus == 0 && canEditRequest == true" v-show="!isEdit" @click="edit" icon="edit" bold :text="lang.button_Edit" :tooltip="lang.button_Edit" :disabled="editButtonStatus" />

          <action-button v-if="buttonIsVisible && currentUser.role != 'Reader' && tabStatus == 0 && canEditRequest == true" v-show="isEdit" @click="unedit" icon="edit" bold :text="lang.button_Unedit" :tooltip="lang.button_Unedit" :disabled="uneditButtonStatus" />
          <action-button v-if="buttonIsVisible && currentUser.role != 'Reader' && tabStatus == 0 && canEditRequest == true" @click="save" icon="save" bold :text="lang.button_Save" :tooltip="lang.button_Save" :disabled="saveButtonStatus" :save="saveStatus" />

          <action-button v-if="requestDetails.type == 'part' && elementId == null && currentUser.role != 'Reader' && tabStatus == 0 && canCreateElement == true" @click="createPart" icon="electrical-part" bold :text="lang.button_CreatePart" :tooltip="lang.button_CreatePart" :disabled="createPartButtonStatus" />

          <action-button v-if="requestDetails.type != 'part' && elementId == null && currentUser.role != 'Reader' && tabStatus == 0 && canCreateElement == true" @click="createLibrary" icon="new" bold :text="lang.button_CreateLibrary" :tooltip="lang.button_CreateLibrary" :disabled="createPartButtonStatus" />

          <!-- <action-button v-if="requestDetails.type == 'library' && elementId == null && currentUser.role != 'Reader' && tabStatus == 0  && canCreateElement == true" @click="createLibrary" icon="footprint" bold :text="lang.button_CreateLibrary" :tooltip="lang.button_CreateLibrary" :disabled="createPartButtonStatus" /> -->

          <action-button v-if="requestDetails.type == 'part' && elementId != null && tabStatus == 0" @click="gotoPart" icon="goto" bold :text="lang.button_GotoPart" :tooltip="lang.button_GotoPart" :disabled="gotoPartButtonStatus" />

          <action-button v-if="requestDetails.type != 'part' && elementId != null && tabStatus == 0" @click="gotoLibrary" icon="goto" bold :text="lang.button_GotoLibrary" :tooltip="lang.button_GotoLibrary" :disabled="gotoPartButtonStatus" />

                           
          <!-- <action-button v-if="currentUser.role == 'Admin' && globalSettings.deletionOfElements && tabStatus == 0" @click="_delete"
            icon="remove" bold :text="lang.button_Delete" :tooltip="lang.button_Delete"
            :disabled="deleteButtonStatus" /> -->
          


          


        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :tooltip="lang.button_Left" :disabled="false" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :tooltip="lang.button_Right" :disabled="false" />

        </b-navbar-nav>
      </action-bar>
      <action-content>

        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'

  import Content from "@/components/RequestManager/Views/RequestDetails/Middle/Content/Content"
  import { mapGetters } from 'vuex'
  import * as Tools from '../../../../../Tools/Tools'


export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content
  },
  props:{
    lang: Object
  },
  data () {
    return {
      saveButtonStatus: true,
      editButtonStatus: false,
      uneditButtonStatus: true,
      backButtonStatus: false,
      upButtonStatus: false,
      
      transferOwnershipButtonStatus: false,
      createPartButtonStatus: false,
      gotoPartButtonStatus: false,
      //deleteButtonStatus: false,
      
      saving: false,
      //lockedRevisionId: "",
      fileCounter: 0,
      fileFeedback: [],
      pushed: false,
      libraryDetails: {},
      tabStatus: 0,
      requestDetails: {}
    }
  },
  computed:{
    ...mapGetters({
      currentUser: 'currentUser',
      isPlugin: 'isPlugin',
      globalSettings: "globalSettings",
      isAgent: 'isAgent',
      
    }),
    
    isEdit(){
      return this.$store.getters.isEditPropertyForm;
    },
    
    
    authorityToChange(){
      return this.$store.getters.authorityToChange;
    },
    
    buttonIsVisible(){
      
      let ret = true;
      // if (this.selectedLastRevisionRow && this.authorityToChange && this.isOwner) {
      
      //   ret = true;
      // }
      // if (this.elementStatus == "active"){
      //   ret = true;
      // }
      
      return ret;
    },
    canEditRequest() {
      return this.$store.getters.requestDetails.canEditRequest;
    },
    canCreateElement() {
      return this.$store.getters.requestDetails.canCreateElement;
    },
    // isOwner() {
      
    //   let ret = false;
    //   if (this.lastRevisionHistory.userId == this.currentUser.userId) {
    //     ret = true;
    //   }
    //   return ret;
    // },
    saveStatus() {
      return this.$store.getters.saveStatus;
    },
    requestId() {

      return this.$route.query.requestId;
    },
    elementId() {
      if (this.$route.query.id == null || this.$route.query.id == undefined || this.$route.query.id == "") {
        return null;
      }
      return this.$route.query.id;
    },
    revisionId() {
      if (this.$route.query.revisionId == null || this.$route.query.revisionId == undefined || this.$route.query.revisionId == "") {
        return null;
      }
      return this.$route.query.revisionId;
    }

  },
  created() {

    this.getRequest();
    
  },
  watch: {
    isEdit: function(newVal){
      

        this.saveButtonStatus = !newVal;
        this.editButtonStatus = newVal;
        this.uneditButtonStatus = !newVal;

    },
    
    // lastRevisionHistory: {
    //   handler: function(newVal, oldVal){
        
        
    //     this.getDetails();
    //   },
    //   deep: true
        
          
    // },
  },

  methods: {
    getRequest() {
      
      let vue = this;

      let obj = {
        requestId: this.requestId
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getRequest", obj)
        .then(function (result) {

          if (result.status == "OK") {

            
            
            vue.requestDetails = result.data;

             

            let elementId = null;
            let revisionId = null;
            if (vue.requestDetails.type == "part") {
              elementId = vue.requestDetails.partId;
              revisionId = vue.requestDetails.partRevisionId;
            }
            if (vue.requestDetails.type != "part") {
              elementId = vue.requestDetails.libraryId;
              revisionId = vue.requestDetails.libraryRevisionId;
            }
           
              
              vue.$router.replace({
                query: {
                  ...vue.$route.query,
                  id: elementId,
                  revisionId: revisionId
                }
              })
          }

        })
      
    },
    switchButtons(index){
      
      this.tabStatus = index;
    },
    
    edit(){
      

      this.$store.dispatch("editPropertiesForm", true);
    },
    unedit(){
      

      this.$store.dispatch("editPropertiesForm", false);
      this.$store.dispatch("setSaveStatus", false);
    },
    save(){
      this.saveButtonStatus = true;

      let vue = this;
      
      

      let trig = false;
        
        
        if (trig == true){
          let obj = {
            text: this.lang.alert_error_edit_required,
            time: 10,
            type: "danger"
          }

          this.$store.dispatch("displayFooterAlert", obj);
          vue.saveButtonStatus = false;
        } else {

          let obj = {
            requestId: vue.$route.query.requestId
          }
          for (let i = 0, lei = this.$store.getters.propertyRequestToSaving.length; i < lei; i++){
            obj[this.$store.getters.propertyRequestToSaving[i].type] = this.$store.getters.propertyRequestToSaving[i].value

          }
                   

          
        

          this.$store.dispatch(this.$store.getters.sectionPrefix + "_updateRequest", obj)
          .then(function(result){
            vue.saveButtonStatus = false;
            console.log(result)

            if (result.status == "OK"){

              if (result.data != 0){
                

                let requestId = result.data;

                vue.saving = true;

                let obj = {
                  text: vue.lang.alert_success_edit_library,
                  time: 10,
                  type: "success"
                }

                vue.$store.dispatch("displayFooterAlert", obj);

                vue.$store.dispatch("setSaveStatus", false);

                if (vue.$store.getters.requestFilesToSaving.length > 0){

                  
                  vue.fileCounter = 0;

                  vue.importFile(vue.$route.query.requestId);
                  
                } else {
                 

                  let reloadObj = {
                    status: true,
                    name: "RequestDetailsComponent",
                    source: ""
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                  reloadObj = {
                    status: true,
                    name: "DataTableFilteredOnApiRequestsComponent",
                    source: ""
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                  
                  reloadObj = {
                    status: true,
                    name: "ExternalSearchRequestComponent",
                    source: ""
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                }



              }else{

                let obj = {
                  text: vue.lang.alert_error_edit_library + ".",
                  time: 15,
                  type: "danger"
                }

                vue.$store.dispatch("displayFooterAlert", obj);

              }
              

            }else{

              

              let obj = {
                text: vue.lang.alert_error_edit_library + ": " + result.message,
                time: 15,
                type: "danger"
              }

              vue.$store.dispatch("displayFooterAlert", obj);

            }



          })


        }

    },
    
    importFile(requestId){

      this.$store.dispatch("showLoader", {visible: true, text: "push"});
      
      let vue = this;
      
      let lei = vue.$store.getters.requestFilesToSaving.length;
      


      const obj = {
        requestId: requestId,
        file: vue.$store.getters.requestFilesToSaving[vue.fileCounter],
        lastModified: Tools.IntegerToIntegerUTC(vue.$store.getters.requestFilesToSaving[vue.fileCounter].lastModified)
        
      }
      
      let fileName = vue.$store.getters.requestFilesToSaving[vue.fileCounter].name;
      
      vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_importRequestFile", obj)
      .then(function(result){
        console.log(result);
        let obj2 = {};
        if (result.status == "OK"){
          
          obj2 = {
            result: "Added",
            fileName: fileName,            
            
          }
          
        }else{
          
          
          obj2 = {
            result: result.message,
            fileName: fileName,            
            
          }
          
          
        }
        vue.fileFeedback.push(obj2);
        
        
        vue.fileCounter++;
        
          if (vue.fileCounter > lei - 1){
            
            vue.$store.dispatch("showLoader", { visible: false, text: "" }); 

            

            const reloadObj = {
              status: true,
              name: "RequestDetailsComponent",
              source: ""
            }
            vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

            if (vue.fileFeedback.length > 0) {

              let func = function () {
                vue.fileFeedback = [];
                //vue.toDetails(requestId); 
              }

              
              const dataFiles = {
                fileImportResults: {},
                newRevisionId: null
              }
              for (let i = 0, lei = vue.fileFeedback.length; i < lei; i++){

                const obj = {
                  result: vue.fileFeedback[i].result,
                            
                  
                }
                
                dataFiles.fileImportResults[vue.fileFeedback[i].fileName] = obj;
              }
              vue.$store.dispatch("showLoader", {visible: false, text:""});
              vue.fileFeedback = [];

              const obj = {
                title: vue.lang.modal_title_PushLibrary,
                text: "",
                type: "push_files",
                buttons: 1,
                buttonName: "Close",
                // buttonWait: buttonWait,
                // commentWait: commentWait,
                size: "xl",
                lang: vue.lang.modal_PushRequest,
                funcNo: "",
                funcYes: "",
                funcCustom: func,
                data: dataFiles
              };
              
              vue.$store.dispatch("showModalComponent", obj);
            }

            
            
          }else{
            
            vue.importFile(requestId);
          }

      })
    },
    
    
    
    
    
    _delete() {

      let vue = this;

      let requestId = this.$route.query.requestId;

      let deleteRequestFunc = function () {

        
        const arr = {
          requestIds: [requestId]
        }

        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_deleteRequest", arr)
          .then((result) => {

            console.log(result)
            let obj = {};
            if (result.status == "OK") {

              if (result.data != null) {

                
                if (result.data[0].success == true) {
                  obj = {
                    text: vue.lang.alert_success_delete_library,
                    time: 10,
                    type: "success"
                  }

                  const reloadObj = {
                    status: true,
                    name: "DataTableFilteredOnApiLibComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                  let to = "/LibraryManager/LibraryTable";
                  const query = {
                    from: vue.$route.path,
                    to: to,
                    source: "LibraryDetails",

                  }

                  vue.$router.push({ path: to, query: query });
                } else {
                  obj = {
                    text: vue.lang.alert_error_delete_library + ": " + result.data[0].message,
                    time: 15,
                    type: "danger"
                  }
                }
                  
                
                

              } else {
                obj = {
                  text: vue.lang.alert_error_delete_library + ": " + result.message,
                  time: 15,
                  type: "danger"
                }

              }
            } else {
              obj = {
                text: vue.lang.alert_error_delete_library + ": " + result.message,
                time: 15,
                type: "danger"
              }

            }
            vue.$store.dispatch("displayFooterAlert", obj);
          })
      }

      const obj = {
        title: vue.lang.modal_title_delete,
        text: vue.lang.alert_delete,
        type: "sure",
        buttons: 2,
        size: "sm",
        funcYes: deleteRequestFunc,
        funcNo: ""
      };

      this.$store.dispatch("showAlert", obj);
      
    },
    
    createPart() {
      let to = "/PartManager/PartNew";
            

      const query = {
        from: this.$route.path,
        to: to,
        requestId: this.requestId
      }

      this.$router.push({ path: to, query: query });
      
    },
    createLibrary() {
      let to = "/LibraryManager/LibraryNew";
            

      const query = {
        from: this.$route.path,
        to: to,
        requestId: this.requestId
      }

      this.$router.push({ path: to, query: query });
      
    },
    gotoPart() {
      this.$store.dispatch("deleteAllSelectedRows");
      this.$store.commit("DELETEALLREQUESTSELECTEDROWS");

      let to = "/PartManager/PartDetails";
      let obj = {
        col___revisionId: {
          revisionId: this.revisionId,
          partId: this.elementId
        },
        col___revision: {
          revisionId: this.revisionId

        },
        col___status: {
          assembly: false

        }
      }

      this.$store.dispatch("setSelectedRows", [obj]);

      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);

      
      let routingObject = {
        from: this.$route.path,
        to: to,
        end: false,
        revisionId: this.revisionId,
        id: this.elementId,
        requestId: this.requestId,
        sourceType: "details",
        
      }
 
      this.$store.commit("FORWARDROUTINGDATA", routingObject)
      
      this.$router.push({ path: to, query: routingObject });
      
    },
    gotoLibrary() {
      this.$store.dispatch("deleteAllSelectedRows");
      this.$store.commit("DELETEALLREQUESTSELECTEDROWS");
      

      let to = "/LibraryManager/LibraryDetails";
      let obj = {
        col___revisionId: {
          revisionId: this.revisionId,
          libraryId: this.elementId
        },
        col___revision: {
          revisionId: this.revisionId

        },
        col___status: {
          assembly: false

        }
      }

      this.$store.dispatch("setSelectedRows", [obj]);

      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);

      let routingObject = {
        from: this.$route.path,
        to: to,
        end: false,
        revisionId: this.revisionId,
        id: this.elementId,
        requestId: this.requestId,
        sourceType: "details",
        
      }
  
      this.$store.commit("FORWARDROUTINGDATA", routingObject)
      
      this.$router.push({ path: to, query: routingObject });
    },
    up(){
      this.$store.commit("RESETROUTINGDATA");

      this.$store.dispatch("setSaveStatus", false);
      this.$store.commit("RESETPROPERTYREQUESTTOSAVING");

      if (this.saving) {

        const reloadObj = {
          status: true,
          name: "DataTableFilteredOnApiRequestsComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);


      }
      

      let to = "/RequestManager/RequestTable";
      
      this.$router.push({ path: to });

    },
    back() {

      this.$store.dispatch("setSaveStatus", false);
      this.$store.commit("RESETPROPERTYREQUESTTOSAVING");

      
      

      if (this.saving) {

        const reloadObj = {
          status: true,
          name: "DataTableFilteredOnApiRequestsComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);


      }

      //#####################################################################
      let query = {};
      let to = "";

      if (this.$store.getters.routingData.length == 0) {
        if (this.$store.getters.sectionPrefix == "pm") {
          to = "/PartManager/PartTable";
        }
        if (this.$store.getters.sectionPrefix == "lm") {
          to = "/LibraryManager/LibraryTable";
        }
        if (this.$store.getters.sectionPrefix == "projm") {
          if (this.$route.path == "ProjectManager/ProjectBom") {
            to = "/ProjectManager/ProjectDetails";
          } else {
            to = "/ProjectManager/ProjectTable";
          }
        }
        if (this.$store.getters.sectionPrefix == "rm") {
          to = "/RequestManager/RequestTable";
        }

        
      } else {
        to = this.$store.getters.routingData[this.$store.getters.routingData.length - 1].from;
        if (this.$store.getters.routingData[this.$store.getters.routingData.length - 1].end == true) {
          if (this.$store.getters.sectionPrefix == "pm") {
            to = "/PartManager/PartTable";
          }
          if (this.$store.getters.sectionPrefix == "lm") {
            to = "/LibraryManager/LibraryTable";
          }
          if (this.$store.getters.sectionPrefix == "projm") {
            if (this.$route.path == "ProjectManager/ProjectBom") {
              to = "/ProjectManager/ProjectDetails";
            } else {
              to = "/ProjectManager/ProjectTable";
            }
          }
          if (this.$store.getters.sectionPrefix == "rm") {
            to = "/RequestManager/RequestTable";
          }

        }

        query = {
          from: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].to,
          to: to,
          end: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].end,
          revisionId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceRevisionId,
          id: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceId
        }
        if (to == "/ProjectManager/ProjectBom") {
          query.bomId = this.$store.getters.routingData[this.$store.getters.routingData.length - 1].bomId;

        }
        if (this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceType == "main") {
          query = {};
        } else if (this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceType == "details") {

          const goalObj = {
            to: to,
            revisionId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceRevisionId,
            id: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceId,
            selectedBomRow: [{ bomId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].bomId }]
          }
          if (to != "/RequestManager/RequestTable") {
            this.selectRow(goalObj);
          }
          
        }
       
        this.$store.commit("BACKROUTINGDATA");
      }

      
      
      this.$router.push({ path: to, query: query });
      
    },
    selectRow(goalObj) {
      

      

      let obj = {};

      if (goalObj.to == "/PartManager/PartDetails") {
        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },

        }
      }

      if (goalObj.to == "/LibraryManager/LibraryDetails") {
        let id = goalObj.id;

        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            userId: goalObj.userId,
            value: {
              display: goalObj.revisionId
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: goalObj.revision
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___libraryType: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }
          },

        }
      }

      




      this.$store.commit("DELETEALLREQUESTSELECTEDROWS");
      
      this.$store.commit("SETREQUESTSELECTEDROWS", [obj]);

      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);
    },
    
    toggleRightPanel(){
      
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
      
    },
    toggleLeftPanel(){
      
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      
    }
  }
}
</script>


<style scoped>
  .middle{
    border-right: 1px solid #666;
    width: 30%;
  }
</style>



// WEBPACK FOOTER //
// src/components/RequestManager/Views/RequestDetails/Middle/Middle.vue